import React from "react";

var SpinnerIcon = function SpinnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 12c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2s.9 2 2 2h3c1.1 0 2-.9 2-2zm15-2h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3c1.1 0 2-.9 2-2s-.9-2-2-2zM12 0c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2s2-.9 2-2V2c0-1.1-.9-2-2-2zm0 17c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-1.1-.9-2-2-2zm6.364-8.536l2.121-2.121c.778-.778.778-2.051 0-2.829s-2.051-.778-2.828 0l-2.121 2.121c-.778.778-.778 2.051 0 2.828s2.05.779 2.828.001zM5.636 15.536l-2.121 2.121a2.005 2.005 0 0 0 0 2.828 2.005 2.005 0 0 0 2.828 0l2.121-2.121c.778-.778.778-2.051 0-2.828s-2.05-.778-2.828 0zm12.728 0a2.005 2.005 0 0 0-2.828 0 2.005 2.005 0 0 0 0 2.828l2.121 2.121c.778.778 2.051.778 2.828 0s.778-2.051 0-2.829zM5.636 8.465a2.005 2.005 0 0 0 2.828 0 2.005 2.005 0 0 0 0-2.828L6.343 3.515c-.778-.778-2.051-.778-2.828 0s-.778 2.051 0 2.829z"
  }));
};

SpinnerIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
SpinnerIcon.defaultProps.solid = true;
export default SpinnerIcon;